<div class="qr-error-container min-h-screen flex flex-col items-center justify-center p-6">
    <!-- Error Icon using SVG -->
    <img src="/assets/logos/info-icon.svg" alt="Info Icon" class="qr-error-icon mb-8">

    <!-- Error Message -->
    <h1 class="qr-error-title text-center mb-6">
        We're having trouble<br>detecting a Smart QR Code
    </h1>

    <!-- Instruction Card using PrimeNG Card -->
    <p-card styleClass="qr-error-card mb-8">
        <ng-template pTemplate="content">
            <div class="text-center">
                <!-- Logo Image -->
                <img src="/assets/logos/logo-min-dark.svg" alt="Logo" class="qr-logo">

                <!-- Troubleshooting Text -->
                <p class="qr-error-help-text">
                    Make sure the Smart QR Code is well lit and in focus
                </p>
            </div>
        </ng-template>
    </p-card>

    <!-- Action Button using PrimeNG Button -->
    <div class="qr-button-container">
        <p-button label="Try Again" size="large" styleClass="qr-retry-button" (onClick)="retryScan()">
        </p-button>
    </div>
</div>